import React from 'react';
import './LandingSections.css';

const TrainingLevels = () => {
  return (
    <section className="training-levels-section">
      <div className="container">
        <h2>Training for All Levels: From First Move to Grandmaster Strategy</h2>
        <p>
          Whether you're just learning how the pieces move or you're an
          experienced player fighting for every ELO point, our comprehensive
          training system is designed to meet you where you are and propel you
          forward. Our curriculum, taught by <strong>seasoned coaches</strong> with
          competitive experience, covers the entire spectrum of chess mastery.
          You will learn everything from foundational <strong>Opening Principles</strong> and
          crucial <strong>Endgame Techniques</strong> to deep <strong>Mid-Game Concepts</strong> and
          advanced elements like <strong>Positional Sacrifices</strong>.
        </p>
      </div>
    </section>
  );
};

export default TrainingLevels;
